import {Model} from "@vuex-orm/core";

export default class WebsiteWidgetCategoryShortcutWebsiteCategory extends Model {
    static entity = 'websiteWidgetCategoryShortcutWebsiteCategory'

    static primaryKey = ['website_widget_category_shortcut_id', 'website_category_id']

    static fields () {
        return {
            website_widget_category_shortcut_id: this.number(null),
            website_category_id: this.number(null)
        }
    }
}
